export default __webpack_public_path__ + "static/6870-640ab24bbef08c4bae1b43d46be1d45e.jpg";